module.exports = __webpack_public_path__ + "img/icon_map_ddsh.34042ae5.png";